const Button = ({ name, styles, event }) => {
    return (<>
        <div className="container p-1">
            <button className={styles} onClick={event}>{name}</button>
        </div>

    </>);
}

export default Button;